export type {PageLayoutProps, PageLayoutHeaderProps, PageLayoutContentProps} from './PageLayout';

// Export all components directly
export {PageLayout, PageLayoutHeader, PageLayoutContent, usePageLayout} from './PageLayout';
